import { useEffect } from 'react';
import { useJourney } from '../contexts/JourneyContext';
import ScreenLobby from './ScreenLobby';
import ScreenLocationHunt from './ScreenLocationHunt';

const ScreenHunt = (props) => {

  const journey = useJourney();

  const onComplete = () => {
    journey.finishedAtLocation();
  }

  useEffect(() => {
    // if we're starting and have no visited locations, get a location and start the hunt
    // but only if the journey isn't already complete
    if (journey.isFirstHunt() && journey.selectedLocation == null && !journey.isLoading && !journey.isJourneyComplete) {
      //console.log("Starting first hunt, getting next location");
      journey.startNextLocation();
    }
  }, [journey]);

  if (journey.selectedLocation) {
    //console.log("Selected location, showing hunt screen");
    return <ScreenLocationHunt onComplete={onComplete} />;
  } else {
    //console.log("No selected location, showing lobby");
    return <ScreenLobby />;
  }
};

export default ScreenHunt;
